"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicIcon = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const MosaicIcon = props => {
    const { name, className = '' } = props, restProps = tslib_1.__rest(props, ["name", "className"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", className: `df-icon ${className}` }, restProps, { children: (0, jsx_runtime_1.jsx)("use", { href: `/static/icons/${name}.svg#${name}` }) })));
};
exports.MosaicIcon = MosaicIcon;
